import {Component, OnInit} from '@angular/core';
import {HttpService} from '../../../../services/http.service';
import {PriceMatrixFilter} from '../../../../models/config/price-matrix-filter.model';
import {AgeMileageMatrix} from '../../../../models/config/agemileagematrix.model';
import {Brand} from '../../../../brand/brand.model';
import {BrandService} from '../../../../brand/brand.service';
import {ModelGroup} from '../../../../model-group/model-group.model';
import {PricingDto} from '../../../../models/config/pricing-dto.model';
import {PricingMatrix} from '../../../../models/config/pricing-matrix.model';
import {SweetUtil} from '../../../commons/sweet/sweet-util-service';

@Component({
  selector: 'app-pricing-matrix',
  templateUrl: './pricing-matrix.component.html',
  styleUrls: ['./pricing-matrix.component.scss']
})
export class PricingMatrixComponent implements OnInit {
  periods: Array<number> = [2021, 2022, 2023];
  filter: PriceMatrixFilter = new PriceMatrixFilter();
  ageMileageMatrix: AgeMileageMatrix;
  selectedBrand: Brand = null;
  selectedPeriod = 2022;
  brands: Array<Brand> = [];
  modelGroups: Array<ModelGroup> = [];
  matrix: Array<PricingDto> = [];
  headers: Array<PricingMatrix> = [];

  constructor(private http: HttpService, private brandService: BrandService, private sweetUtil: SweetUtil) {
  }

  ngOnInit(): void {
    this.brandService.all().subscribe((brands: Brand[]) => {
      this.brands = brands;
      this.selectedBrand = this.brands[0];
      this.filter.brand = this.selectedBrand.id;
      this.filter.year = this.selectedPeriod;
      this.fetchPricingMatrix();
    });
  }

  fetchPricingMatrix() {
    this.http.getPricingMatrix(this.filter).subscribe(data => {
      this.matrix = data;
      if (this.matrix && this.matrix.length > 0) {
        this.headers = this.matrix[0].pricingMatrices;
      }
    });
  }

  onBrandSelected() {
    this.filter.brand = this.selectedBrand.id;
    this.fetchPricingMatrix();
  }

  onYearSelected() {
    this.filter.year = this.selectedPeriod;
    this.fetchPricingMatrix();
  }

  update() {
    this.http.savePricingMatrix(this.matrix, this.selectedPeriod).subscribe(data => {
        SweetUtil.showSuccess('Updated configuration').then();
      }, error => {
        this.sweetUtil.showError('Internal server error. Please try again later.').then();
      });
  }

  getAgeInYears(age: number) {
    if (!age) {
      return 0;
    }
    return Math.round(age / 12);
  }
}
